import template from './templates/error.tmpl';
import localize from   '../../localize';
import AppSettings from '../../AppSettings';

export default class CustomError {
	constructor (parentElement, errDescription, opt = {}) {
		this.parentElement = parentElement;
		this.renderedTemplate = template;
		this.parentElement.innerHTML = this.renderedTemplate;
		this.el = this.parentElement.querySelector(".error-view");

		// Title and descriptions
		this.errDescription = errDescription;
		this.errorTitle = opt.errorTitle; 

		if (AppSettings.Language) {
			localize(parentElement, AppSettings.Language);
			this.el.querySelector('.error--title').innerHTML = this.errorTitle;
			this.el.querySelector('.error--text').innerHTML =  this.errDescription;
		}

	}
}


//todo  pass error message into error container

